module.exports = __webpack_public_path__ + "images/d7bef08c73f5280e1846b911f8ae95d182de3731f99bd51c9e25c9c7c2bdfe4d.svg";